import {isEmpty, map} from 'lodash';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import ScreenInfoMessage from './ScreenInfoMessage';

const ScreenError = ({errors}) =>
  !isEmpty(errors) ? (
    <div>
      {map(errors, (value, key) => (
        <ScreenInfoMessage key={key} text={value} />
      ))}
    </div>
  ) : null;

ScreenError.displayName = 'ScreenError';

ScreenError.propTypes = {
  errors: PropTypes.objectOf(PropTypes.any),
};

ScreenError.defaultProps = {
  errors: undefined,
};

export default ScreenError;
